module.exports = __webpack_public_path__ + "img/violet_008.46839dad.png";